import { governedNavEnabled } from "../../app/governedNav.js";

export function homeNavEnabled({ flagsReady, flags, nav_config: navConfig, nav_order: navOrder }, key) {
  return flagsReady && governedNavEnabled(flags, navConfig, key, navOrder);
}